const currentLocale = new Intl.Locale(navigator.languages[0]);

export default currentLocale;
